(()=>{'use strict';
function addPdpConfidence(){ return; }
function addCartHelp(){
 const side=document.querySelector('#MainContent [class~="#cart-sidebar-wrapper"], #MainContent [class*="sidebar-wrapper"]'); if(!side||side.querySelector('.xpn-cart-help'))return;
 const help=document.createElement('div'); help.className='xpn-cart-help';
 help.innerHTML='<strong>Want to confirm the part before checkout?</strong><span>Bubba can help verify the model, vehicle or part you are ordering.</span><br><button type="button" data-xpv-assistant>Ask Bubba →</button>';
 side.appendChild(help);
}
function closeOtherMenus(){
 document.addEventListener('toggle',e=>{
  const d=e.target;if(!(d instanceof HTMLDetailsElement)||!d.matches('.xpn-navigation details')||!d.open)return;
  document.querySelectorAll('.xpn-navigation details[open]').forEach(other=>{if(other!==d)other.removeAttribute('open')});
 },true);
}

function installRepairContext(){
 if(window.XPartRepairContextInstalled)return;window.XPartRepairContextInstalled=true;
 const VEHICLE_KEY='xpart_locked_vehicle_v1';
 const readVehicle=()=>{try{const v=JSON.parse(localStorage.getItem(VEHICLE_KEY)||'null');return v&&v.year&&v.make&&v.model?v:null;}catch{return null;}};
 const setVehicle=value=>{const next={year:String(value.year||'').trim(),make:String(value.make||'').trim(),model:String(value.model||'').trim(),engine:String(value.engine||'').trim()};if(!(next.year&&next.make&&next.model))return null;try{localStorage.setItem(VEHICLE_KEY,JSON.stringify(next));}catch{}window.dispatchEvent(new CustomEvent('xpart:vehicle-changed',{detail:next}));return next;};
 const clearVehicle=()=>{try{localStorage.removeItem(VEHICLE_KEY);}catch{}window.dispatchEvent(new CustomEvent('xpart:vehicle-changed',{detail:null}));};
 window.XPartVehicleLock={get:readVehicle,set:setVehicle,clear:clearVehicle};
 const vehicleText=v=>v?[v.year,v.make,v.model,v.engine].filter(Boolean).join(' '):'';
 const vehicleUrl=v=>{if(!v)return'/pages/vehicle-parts-finder';const p=new URLSearchParams({year:v.year,make:v.make,model:v.model});if(v.engine)p.set('engine',v.engine);return'/pages/vehicle-parts-finder?'+p.toString();};
 const captureVehicle=()=>{if(location.pathname!='/pages/vehicle-parts-finder')return;const p=new URLSearchParams(location.search);const year=p.get('year'),make=p.get('make'),model=p.get('model'),engine=p.get('engine');if(year&&make&&model)setVehicle({year,make,model,engine});};
 const render=()=>{const appliance=window.XPartModelLock?.get?.()||null,vehicle=readVehicle();document.querySelectorAll('[data-xp-context-strip]').forEach(strip=>{strip.hidden=!(appliance||vehicle);const ac=strip.querySelector('[data-xp-model-chip]');if(ac){ac.hidden=!appliance;ac.querySelector('[data-xp-model-number]')?.replaceChildren(document.createTextNode(appliance?.model||''));const al=ac.querySelector('[data-xp-model-hub-link]');if(al){al.hidden=!appliance?.url;if(appliance?.url){try{const hub=new URL(appliance.url,location.origin);if(hub.origin===location.origin&&hub.pathname.startsWith('/pages/'))al.href=hub.pathname;else{al.hidden=true;al.removeAttribute('href');}}catch{al.hidden=true;al.removeAttribute('href');}}}}const vc=strip.querySelector('[data-xp-vehicle-chip]');if(vc){vc.hidden=!vehicle;vc.querySelector('[data-xp-vehicle-text]')?.replaceChildren(document.createTextNode(vehicleText(vehicle)));const vl=vc.querySelector('[data-xp-vehicle-open]');if(vl)vl.href=vehicleUrl(vehicle);}});document.querySelectorAll('[data-xp-vehicle-link]').forEach(link=>{link.href=vehicleUrl(vehicle);link.textContent=vehicle?'Continue with '+vehicleText(vehicle)+' →':'Add my vehicle →';});if(!appliance&&vehicle)document.querySelectorAll('.xpv-header-search input[name="q"]').forEach(input=>{input.placeholder='Search parts for '+vehicleText(vehicle);});};
 document.addEventListener('submit',e=>{const form=e.target.closest('#xp-vehicle-finder form');if(!form)return;const year=form.querySelector('[name="year"]')?.value,make=form.querySelector('[name="make"]')?.value,model=form.querySelector('[name="model"]')?.value,engine=form.querySelector('[name="engine"]')?.value;if(year&&make&&model)setVehicle({year,make,model,engine});},{capture:true});
 document.addEventListener('click',e=>{if(e.target.closest('[data-xp-vehicle-change]')){clearVehicle();render();return;}if(e.target.closest('#xp-vehicle-finder [data-clear]')){clearVehicle();render();}},{capture:true});
 window.addEventListener('xpart:model-changed',render);window.addEventListener('xpart:vehicle-changed',render);window.addEventListener('pageshow',()=>{captureVehicle();render();});captureVehicle();render();
}
function cleanDuplicatePageHeading(){const pageHeader=document.querySelector('#MainContent [class~="#page-header"] h1');if(!pageHeader)return;document.querySelectorAll('#MainContent [class~="#rte"]').forEach(rte=>{const first=rte.querySelector(':scope > h1:first-child');if(first&&first.textContent.trim().toLowerCase()===pageHeader.textContent.trim().toLowerCase())first.hidden=true;});}

function run(){if(document.querySelector('xpart-home-napa, xpart-smart-home'))document.body.classList.add('xpn-homepage');addPdpConfidence();addCartHelp();closeOtherMenus();installRepairContext();cleanDuplicatePageHeading();}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();
new MutationObserver(()=>{addPdpConfidence();addCartHelp();}).observe(document.documentElement,{subtree:true,childList:true});
})();
/* === My Repair signature interaction v14 === */
(()=>{
  if(window.XPartRepairMomentInstalled)return;
  window.XPartRepairMomentInstalled=true;
  const SESSION_KEY='xpart_repair_moment_last_v1';
  let hideTimer=0;

  const vehicleText=v=>v?[v.year,v.make,v.model,v.engine].filter(Boolean).join(' '):'';

  const getToast=()=>{
    let toast=document.querySelector('[data-xp-repair-moment]');
    if(toast)return toast;
    toast=document.createElement('div');
    toast.className='xprm-lock';
    toast.hidden=true;
    toast.setAttribute('data-xp-repair-moment','');
    toast.setAttribute('role','status');
    toast.setAttribute('aria-live','polite');
    toast.innerHTML='<i class="xprm-lock__scan" aria-hidden="true"></i><span class="xprm-lock__check" aria-hidden="true">✓</span><span class="xprm-lock__copy"><small>My Repair</small><strong>Repair locked</strong><b data-xprm-target></b><em data-xprm-note></em></span><span class="xprm-lock__star" aria-hidden="true">✦</span>';
    document.body.appendChild(toast);
    return toast;
  };

  const pulseStrip=()=>{
    document.querySelectorAll('[data-xp-context-strip]').forEach(strip=>{
      strip.classList.remove('xpv-context-strip--locked');
      void strip.offsetWidth;
      strip.classList.add('xpv-context-strip--locked');
      setTimeout(()=>strip.classList.remove('xpv-context-strip--locked'),1200);
    });
  };

  const show=(kind,label)=>{
    label=String(label||'').trim();
    if(!label)return;
    const signature=kind+'::'+label.toUpperCase();
    try{
      if(sessionStorage.getItem(SESSION_KEY)===signature)return;
      sessionStorage.setItem(SESSION_KEY,signature);
    }catch{}
    const toast=getToast();
    toast.querySelector('[data-xprm-target]').textContent=label;
    toast.querySelector('[data-xprm-note]').textContent=kind==='vehicle'?'Vehicle saved for your parts search.':'Appliance saved for your parts search.';
    toast.hidden=false;
    toast.classList.remove('xprm-lock--show');
    void toast.offsetWidth;
    toast.classList.add('xprm-lock--show');
    pulseStrip();
    clearTimeout(hideTimer);
    hideTimer=setTimeout(()=>{
      toast.classList.remove('xprm-lock--show');
      setTimeout(()=>{toast.hidden=true;},260);
    },3100);
  };

  window.addEventListener('xpart:model-changed',event=>{
    const v=event.detail;
    if(v?.model)show('appliance',v.model);
  });
  window.addEventListener('xpart:vehicle-changed',event=>{
    const v=event.detail;
    if(v?.year&&v?.make&&v?.model)show('vehicle',vehicleText(v));
  });
})();

/* === Site-wide conversion behavior v34 === */
(()=>{
  if(window.XPartConversionPass34)return;
  window.XPartConversionPass34=true;

  const normalize=value=>String(value||'').toUpperCase().replace(/[^A-Z0-9]/g,'');

  function upgradeSearch(){
    const root=document.querySelector('.xpf18[data-search="true"]');
    if(!root)return;
    const input=root.querySelector('.xpf18-query input[name="q"]');
    const raw=(input?.value||new URLSearchParams(location.search).get('q')||'').trim();
    const identifier=/^[A-Za-z0-9.\/_-]{3,}$/.test(raw)&&/\d/.test(raw);
    if(!identifier)return;
    const key=normalize(raw);
    const list=root.querySelector('.xpf18-list');
    if(!list||list.dataset.xpExactSorted===key)return;
    const rows=[...list.querySelectorAll('.xpf18-row')];
    const exact=rows.filter(row=>normalize(row.querySelector('.xpf18-part-info h2')?.textContent||'').includes(key));
    if(!exact.length){list.dataset.xpExactSorted=key;return;}
    exact.forEach(row=>row.classList.add('xpf18-exact-match'));
    const first=exact[0];
    const info=first.querySelector('.xpf18-part-info');
    if(info&&!info.querySelector('.xpf18-exact-badge')){
      const badge=document.createElement('span');
      badge.className='xpf18-exact-badge';
      badge.textContent='Best part-number match';
      info.prepend(badge);
    }
    const heading=list.querySelector('.xpf18-table-heading');
    let anchor=heading;
    for(const row of exact){ if(anchor){anchor.after(row);anchor=row;} }
    list.dataset.xpExactSorted=key;
  }

  function upgradeVehicleFinder(){
    const finder=document.querySelector('#xp-vehicle-finder');
    if(!finder)return;
    let banner=finder.querySelector('.xpn-vehicle-context');
    const vehicle=window.XPartVehicleLock?.get?.();
    if(!vehicle){banner?.remove();return;}
    const label=[vehicle.year,vehicle.make,vehicle.model,vehicle.engine].filter(Boolean).join(' ');
    if(!banner){
      banner=document.createElement('div');
      banner.className='xpn-vehicle-context';
      finder.prepend(banner);
    }
    if(banner.dataset.xpVehicleSignature===label)return;
    banner.dataset.xpVehicleSignature=label;
    banner.innerHTML='<div><span>My Garage</span><strong></strong></div><button type="button" data-xp-vehicle-change>Change vehicle</button>';
    banner.querySelector('strong').textContent=label;
  }

  function upgradeCart(){
    const cart=document.querySelector('x-cart');
    const sidebar=cart?.querySelector('[class~="#cart-sidebar"]');
    if(!sidebar||sidebar.querySelector('.xpn-cart-summary-head'))return;
    const head=document.createElement('div');
    head.className='xpn-cart-summary-head';
    head.innerHTML='<span>Checkout</span><strong>Review your order</strong>';
    sidebar.prepend(head);
  }

  const run=()=>{upgradeSearch();upgradeVehicleFinder();upgradeCart();};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();
  window.addEventListener('pageshow',run);
  window.addEventListener('xpart:vehicle-changed',upgradeVehicleFinder);
  let queued=false;
  new MutationObserver(()=>{
    if(queued)return;queued=true;
    requestAnimationFrame(()=>{queued=false;run();});
  }).observe(document.documentElement,{subtree:true,childList:true});
})();

/* === My Repair + My Garage unified context system v35 === */
(()=>{
  if(window.XPartUnifiedContext35)return;
  window.XPartUnifiedContext35=true;

  const vehicleText=v=>v?[v.year,v.make,v.model,v.engine].filter(Boolean).join(' '):'';
  const applianceText=v=>v?[v.brand,v.model].filter(Boolean).join(' '):'';
  const hubPath=value=>{
    try{
      const hub=new URL(value||'',location.origin);
      return value&&hub.origin===location.origin&&hub.pathname.startsWith('/pages/')?hub.pathname:'';
    }catch{return '';}
  };

  function setToast(kind,value){
    const toast=document.querySelector('[data-xp-repair-moment]');
    if(!toast)return;
    const small=toast.querySelector('.xprm-lock__copy small');
    const strong=toast.querySelector('.xprm-lock__copy strong');
    const note=toast.querySelector('.xprm-lock__copy em');
    if(kind==='vehicle'){
      if(small)small.textContent='My Garage';
      if(strong)strong.textContent='Vehicle locked';
      if(note)note.textContent='Saved for fitment-sensitive auto parts.';
    }else{
      if(small)small.textContent='My Repair';
      if(strong)strong.textContent='Repair locked';
      if(note)note.textContent='Saved for model-specific appliance parts.';
    }
  }

  function contextMarkup(kind,label,detail){
    const action=kind==='vehicle'
      ? '<button type="button" data-xp-vehicle-change>Change vehicle</button>'
      : '<button type="button" data-xp-model-change>Change appliance</button>';
    return '<span class="xpn-context-lock__check" aria-hidden="true">✓</span>'+
      '<div class="xpn-context-lock__copy"><span>'+(kind==='vehicle'?'My Garage':'My Repair')+'</span><strong></strong><small>'+detail+'</small></div>'+
      action;
  }

  function upgradeVehicleBar(){
    const bar=document.querySelector('.xpn-vehicle-context');
    const vehicle=window.XPartVehicleLock?.get?.();
    if(!bar||!vehicle)return;
    document.body.classList.add('xpn-context-detail-active');
    bar.classList.add('xpn-context-lock','xpn-context-lock--vehicle');
    if(!bar.querySelector('.xpn-context-lock__check')){
      bar.innerHTML=contextMarkup('vehicle',vehicleText(vehicle),'Vehicle locked for parts fitment');
    }
    const strong=bar.querySelector('.xpn-context-lock__copy strong');
    if(strong&&strong.textContent!==vehicleText(vehicle))strong.textContent=vehicleText(vehicle);
  }

  function renderApplianceBar(){
    const main=document.getElementById('MainContent');
    if(!main)return;
    let bar=main.querySelector(':scope > .xpn-appliance-context');
    const appliance=window.XPartModelLock?.get?.();
    const vehicleFinder=location.pathname==='/pages/vehicle-parts-finder';
    const applianceWorkspace=!!document.querySelector('.xpf18[data-search="true"], [data-xp-hub], .xp-model-hub');
    const showFullBar=!!appliance&&applianceWorkspace&&!vehicleFinder;

    if(!showFullBar){
      bar?.remove();
      document.body.classList.remove('xpn-context-detail-active');
      return;
    }

    if(!bar){
      bar=document.createElement('div');
      bar.className='xpn-appliance-context xpn-context-lock xpn-context-lock--appliance';
      bar.setAttribute('role','status');
      main.prepend(bar);
    }

    const label=applianceText(appliance)||appliance.model;
    const signature=JSON.stringify([label,hubPath(appliance.url)]);
    if(bar.dataset.xpContextSignature===signature){
      document.body.classList.add('xpn-context-detail-active');
      return;
    }
    bar.dataset.xpContextSignature=signature;
    bar.innerHTML=contextMarkup('appliance',label,'Appliance locked for model-specific parts');
    const strong=bar.querySelector('.xpn-context-lock__copy strong');
    if(strong)strong.textContent=label;

    if(hubPath(appliance.url)){
      const button=bar.querySelector('[data-xp-model-change]');
      if(button){
        const open=document.createElement('a');
        open.href=hubPath(appliance.url);
        open.className='xpn-context-lock__open';
        open.textContent=hubPath(appliance.url)===location.pathname?'View diagrams':'Open model';
        open.setAttribute('data-xp-open-model','');
        button.before(open);
      }
    }
    document.body.classList.add('xpn-context-detail-active');
  }

  document.addEventListener('click',event=>{
    const link=event.target.closest('[data-xp-open-model]');
    if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    const destination=new URL(link.href,location.origin);
    if(destination.origin!==location.origin||destination.pathname!==location.pathname)return;
    const hub=document.querySelector('[data-xp-hub]');
    const chooser=hub?.querySelector('.xp-model-hub__chooser-title');
    if(!chooser)return;
    event.preventDefault();
    const back=hub.querySelector('[data-xp-back]');
    if(hub.dataset.xpView==='section'&&back)back.click();
    chooser.setAttribute('tabindex','-1');
    chooser.style.scrollMarginTop='180px';
    chooser.focus({preventScroll:true});
    chooser.scrollIntoView({behavior:'smooth',block:'start'});
  });

  function syncHeaderLabel(){
    const appliance=window.XPartModelLock?.get?.();
    const vehicle=window.XPartVehicleLock?.get?.();
    document.querySelectorAll('.xpv-context-strip__label').forEach(label=>{
      const text=appliance&&vehicle?'My Repair + Garage':vehicle?'My Garage':'My Repair';
      if(label.textContent!==text)label.textContent=text;
    });
  }

  function run(){
    upgradeVehicleBar();
    renderApplianceBar();
    syncHeaderLabel();
  }

  window.addEventListener('xpart:model-changed',event=>{
    if(event.detail?.model)setToast('appliance',event.detail);
    requestAnimationFrame(run);
  });
  window.addEventListener('xpart:vehicle-changed',event=>{
    if(event.detail?.year)setToast('vehicle',event.detail);
    requestAnimationFrame(run);
  });
  window.addEventListener('pageshow',run);

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});
  else run();

  let queued=false;
  new MutationObserver(()=>{
    if(queued)return;
    queued=true;
    requestAnimationFrame(()=>{queued=false;run();});
  }).observe(document.documentElement,{childList:true,subtree:true});
})();

/* === Unified Canada + USA trust bar v46 === */
(()=>{
  if(window.XPartUnifiedTrustBar46)return;
  window.XPartUnifiedTrustBar46=true;

  const copy=[
    'Ships across Canada & USA',
    'Canadian warehouse · Kitchener pickup',
    'Most U.S. orders arrive in 7–14 days'
  ];

  const apply=()=>{
    document.querySelectorAll('.xpn-confidence__inner').forEach(inner=>{
      const spans=[...inner.querySelectorAll(':scope > span')];
      copy.forEach((text,index)=>{
        const node=spans[index];
        if(!node)return;
        node.innerHTML='<b>✓</b> '+text;
      });
      inner.querySelector(':scope > button')?.setAttribute('hidden','');
    });
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',apply,{once:true});
  else apply();

  window.addEventListener('pageshow',apply);
  document.addEventListener('shopify:section:load',apply);

  let queued=false;
  new MutationObserver(()=>{
    if(queued)return;
    queued=true;
    requestAnimationFrame(()=>{queued=false;apply();});
  }).observe(document.documentElement,{childList:true,subtree:true});
})();

/* === One universal Canada + USA confidence bar v48 === */
(()=>{
  if(window.XPartUniversalConfidence48)return;
  window.XPartUniversalConfidence48=true;

  const apply=()=>{
    document.querySelectorAll('.xpn-confidence__inner').forEach(inner=>{
      if(inner.querySelector('.xpn-confidence-unified'))return;
      inner.innerHTML=
        '<div class="xpn-confidence-unified" role="note">'+
          '<strong>Canada + USA delivery</strong>'+
          '<span>Most U.S. orders arrive in 7–14 days</span>'+
          '<span>Family-owned 30+ years</span>'+
        '</div>';
    });
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',apply,{once:true});
  else apply();
  window.addEventListener('pageshow',apply);
  document.addEventListener('shopify:section:load',apply);

  let queued=false;
  new MutationObserver(()=>{
    if(queued)return;
    queued=true;
    requestAnimationFrame(()=>{queued=false;apply();});
  }).observe(document.documentElement,{childList:true,subtree:true});
})();

/* === Hard remove trust bars v49 === */
(()=>{
  if(window.XPartTrustBarsRemoved49)return;
  window.XPartTrustBarsRemoved49=true;
  const purge=()=>{
    document.querySelectorAll('.xpn-confidence,.xpn-pdp-confidence').forEach(el=>el.remove());
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',purge,{once:true});
  else purge();
  window.addEventListener('pageshow',purge);
  document.addEventListener('shopify:section:load',purge);
  let queued=false;
  new MutationObserver(()=>{
    if(queued)return;
    queued=true;
    requestAnimationFrame(()=>{queued=false;purge();});
  }).observe(document.documentElement,{subtree:true,childList:true});
})();
